export const MDF_EXPENSES_REQUEST = "MDF_EXPENSES_REQUEST";
export const MDF_EXPENSES_SUCCESS = "MDF_EXPENSES_SUCCESS";
export const MDF_EXPENSES_FAILED = "MDF_EXPENSES_FAILED";
